import capitalizer from "./capitalize";

export default function dataCapitalization(data) {
    const fieldsToKeepLowercase = ["gender", "email", "phone_number","education","nutrition","iron","place_of_delivery",'mode_of_delivery',"cried_at_birth","hospitalization","breast_feeding","solid_food","convulsions","immunization"]; // Define fields that should NOT be capitalized
  
    return Object.fromEntries(
      Object.entries(data).map(([key, value]) => [
        key,
        typeof value === "string"
          ? fieldsToKeepLowercase.includes(key)
            ? value.toLowerCase() // Keep these fields in lowercase
            : capitalizer(value) // Capitalize everything else
          : value,
      ])
    );
  }
  